import { ImportFileUseCase } from '../../../data/usecases/import-files'
import { ImportFileUseCasePhone } from '../../../data/usecases/import-files-phone'
import { makeAxiosHttpClient } from '../../factories'

export const uploadFile = (cdPsicologo: string, cdBloco: string) => {
  return new ImportFileUseCase(
    `/aplicacaoTeste/upload?cdPsicologo=${cdPsicologo}&cdBloco=${cdBloco}`,
    makeAxiosHttpClient()
  )
}
export const fetchUploads = (cdBloco: string) => {
  return new ImportFileUseCase(
    `/aplicacaoTeste/upload?cdBloco=${cdBloco}`,
    makeAxiosHttpClient()
  )
}
export const saveBlock = (cdAplicacaoTeste: number) => {
  return new ImportFileUseCase(
    `/aplicacaoTeste/saveBlock?cdAplicacaoTeste=${cdAplicacaoTeste}`,
    makeAxiosHttpClient()
  )
}
export const updateDescription = () => {
  return new ImportFileUseCase(
    `/aplicacaoTeste/update/upload`,
    makeAxiosHttpClient()
  )
}
export const uploadFilePhone = (cdPsicologo: string, cdBloco: string) => {
  return new ImportFileUseCasePhone(
    `/aplicacaoTeste/upload?cdPsicologo=${cdPsicologo}&cdBloco=${cdBloco}`,
    makeAxiosHttpClient()
  )
}
export const deleteFile = (cdBloco: string, cdUpload: string) => {
  return new ImportFileUseCase(
    `/aplicacaoTeste/delete/upload?cdBloco=${cdBloco}&cdUpload=${cdUpload}`,
    makeAxiosHttpClient()
  )
}
